import { ROUTES } from "navigation/routes";

export const BREADCRUMBS_NAME = {
  [ROUTES.statements]: "All statements",
  [ROUTES.createStatement]: "Create a statement",
  [ROUTES.statementsTransaction]: "List of transactions",
};
